import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const fetchAllForChild = action$ =>
    action$.ofType(Actions.fetchAllForChild.type).mergeMap(({payload}) =>
        Api.fetchAllForChild(payload.childId)
            .map(reports => Actions.fetchAllForChildSuccess.action({reports, childId: payload.childId}))
            .catch(e => Observable.of(Actions.fetchAllForChildFailed.action(e))),
    );

const acknowledge = action$ =>
    action$.ofType(Actions.acknowledge.type).mergeMap(({payload}) =>
        Api.acknowledge(payload.reportId)
            .map(data => Actions.acknowledgeSuccess.action(data))
            .catch(e => Observable.of(Actions.acknowledgeFailed.action(e, payload.reportId))),
    );

const deleteReport = action$ =>
    action$.ofType(Actions.deleteReport.type).mergeMap(({payload}) =>
        showDeleteDialogObservable({
            title: '',
            description: i18next.t('childProfile.accidentIncidentReports.deleteConfirmation'),
        }).mergeMap(selection => {
            if (selection === 'OK') {
                return Api.deleteReport(payload.reportId)
                    .flatMap(() => [
                        Actions.deleteReportSuccess.action({reportId: payload.reportId, childId: payload.childId}),
                        GlobalEventActions.updateSuccess.action(
                            i18next.t('childProfile.accidentIncidentReports.deleted'),
                        ),
                    ])
                    .catch(e => Observable.of(Actions.deleteReportFailed.action(e)));
            } else {
                return Observable.of(Actions.deleteReportAborted.action());
            }
        }),
    );

export default combineEpics(fetchAllForChild, acknowledge, deleteReport);
